import { css } from "styled-components";

import MapControlButtonStyle from "./MapControlButtonStyle";

const MapControlCompassStyle = (icon = null) => css`
  ${MapControlButtonStyle(icon)};
`;

export default MapControlCompassStyle;
